export default __webpack_public_path__ + "static/mockSeikaku2-0f94990ab6687a5a382ef84c1022e5bf.png";